module.exports = __webpack_public_path__ + "static/media/icon_cam.e24935f2.svg";